import {useMemo} from 'react';

import {CulturalAnalysisPdf} from '../../../../features/company/pdf/types';
import {useGetRequest} from '../../../../hooks/useGetRequest';
import {getCultureAnalysisPdfData} from '../../../../lib/api/v1/company-culture';
import {SerializeTo} from '../../../../utils/serializer/serialize';

const serializedData = (data: any) => {
  const toCamelCase = SerializeTo.CamelCase(data) as any;
  const dreamEmployerResults = toCamelCase.dreamEmployerResults || toCamelCase.dreamEmployerLegacyResults;
  const type = toCamelCase.dreamEmployerResults ? 'dream_employer' : 'dream_employer_legacy';
  return {
    ...toCamelCase,
    dreamEmployerResults: {
      ...dreamEmployerResults,
      type,
    } as CulturalAnalysisPdf,
  };
};

export const useCultureAnalysisPdfPage = (surveyId: string, downloadToken: string, language: string) => {
  const fetchPdfData = useMemo(() => {
    return () => getCultureAnalysisPdfData(surveyId, downloadToken, language);
  }, [surveyId, downloadToken, language]);

  const {data, error, loading} = useGetRequest(fetchPdfData, serializedData);

  return {
    data,
    error,
    loading,
  };
};
